export const blockIconsTextformattingMenuBookNew = (
	<span className='material-symbols-outlined'>menu_book</span>
);
